import React, { FC } from 'react';
import { TextLink, Button, Countdown, Image, getProcessedUrl } from '@bfe/moly';
import { safeToFormat } from '@/utils/number';
import { getStage, Stage } from '@/app/biz';
import { useMarket } from '@/store/market';
import { formatLocalTime } from '@/utils/time';
import { useI18n, useUserInfo } from '@spot-fe/base-ui';
import { checkAccountToRegister, sensorsClick } from '@spot-fe/utils';
import { Block } from '@/components/Layout';
import { useRouter } from 'next/navigation';
import styles from './index.module.scss';
import classNames from 'classnames';

interface IProps {
  showList: any[]
}

export const List: FC<IProps> = ({ showList = [] }) => {

  const { t, locale } = useI18n();
  const { isLogin } = useUserInfo();
  const marketStore = useMarket();
  const router = useRouter();

  const getTtokenStatus = (ele) => {
    const currentStage = getStage(ele);
    if (currentStage !== null) {
      return Stage[currentStage]
    }
  }

  const getTtokenStatusWriter = (ele) => {
    const map = {
      Trading: t('inProgress'),
      ToBeDelivered: t('pendingDeliverys'),
      Delivering: t('deliveryInProgress'),
      Completed: t('deliveried'),
      StopTrade: t('stopTrade'),
      Coming: t('comingSoon')
    }
    if (getTtokenStatus(ele) !== undefined) {
      return map[getTtokenStatus(ele)!]
    }
  }

  const showTime = (ele) => {
    const currentInfo = ele
    const getTtokenStatusText = getTtokenStatus(ele)
    if (getTtokenStatusText === Stage['0'] || getTtokenStatusText === Stage['1'] || getTtokenStatusText === Stage['5']) {
      return (
        <div className={styles.time}>
          {formatLocalTime(currentInfo?.tradeBeginTime)} -{' '}
          {currentInfo?.tradeEndTime
            ? formatLocalTime(currentInfo?.tradeEndTime)
            : t('vote_result_pending')}
        </div>
      )
    }
    if (getTtokenStatusText === Stage['2'] || marketStore.currentTabName === '2') {
      return (
        <div className={styles.time}>
          {currentInfo?.deliveryTime ? formatLocalTime(currentInfo?.deliveryTime) : t('vote_result_pending')}
        </div>
      )
    }
    return null
  }

  const showTradeOrDetailBtn = (ele) => {
    const getTtokenStatusText = getTtokenStatus(ele)
    if (marketStore.currentTabName === '1') {
      if (getTtokenStatusText === Stage['1']) {
        return <Button variant="primary" className={styles.tradingBtn} size="small">{t('trading')}</Button>
      }
      return <Button variant="secondaryBrand" className={styles.tradingBtn} size="small">{t('details')}</Button>
    }
    return (
      <TextLink
        variant="primary"
        className={styles.tradingBtn}
        size="small"
        onClick={e => {
          e.stopPropagation()
          window.open(`/${locale}/trade/spot/${ele.tokenName ?? 'BTC'}/${ele.settleToken ?? 'USDT'}`)
        }}
      >
        {t('buy')} {ele.tokenName}
      </TextLink>
    )
  }

  // 72小时之内的为新用户
  const getDiffTime = (time: number) => {
    const d = new Date().getTime()
    const total = (d - time) / 1000
    const ret = total / (60 * 60)
    return ret <= 72
  }

  // 列表标签 new -> hot -> null
  const showLabel = (ele) => {
    if (ele.hotLabel === 2) {
      return <Image className={styles.hot} src={'https://fh-static.bycsi.com/hot-8d1c84ee1b1c30beadd4fb7239e169a3.svg'} alt="" />
    }
    if (getDiffTime(ele.tradeBeginTime)) return <p className={styles.new}>New</p>
    return null
  }

  const go = (name) => {
    sensorsClick({
      page_name: 'PremarketHome',
      button_name: 'PremarketList',
      token_name: name ?? ''
    })
    if (marketStore.currentTabName === '1' && !isLogin && checkAccountToRegister('spot_premarket_ongoing')) {
      return;
    }
    router.push(`/${locale}/trade/spot/pre-market/detail?token=${name}`)
  }

  const showItmes = (ele) => {
    if (marketStore.currentTabName === '1') {
      // 没有最新成交价 不展示涨跌幅
      // 交易结束和交割中、待交割不展示涨跌幅
      const hideQuoteChange = !ele?.tokenDataCalculationDTO?.lastPrice ||
        [Stage.ToBeDelivered, Stage.Delivering, Stage.Completed].indexOf(getStage(ele) as Stage) > -1
      const quoteChange = Number(ele?.tokenDataCalculationDTO?.quoteChange || '0')
      const quoteIsDown = quoteChange < 0
      return [
        {
          title: t('lastTradedPriceCoin', { coin: ele.settleToken }),
          val: (
            <div>
              {ele?.tokenDataCalculationDTO?.lastPrice || '--'}
              &nbsp;
              {hideQuoteChange ? null : <span
                className={classNames(styles.quoteChange,
                  {
                    [styles.quoteChangeDown]: quoteIsDown
                  }
                )}
              >{`(${quoteChange > 0 ? '+' : ''}${quoteChange.toFixed(2)}%)`}</span>}
            </div>)
        },
        {
          title: `${t('twentyFourHVolume')}(${ele.settleToken})`,
          val: ele?.tokenDataCalculationDTO?.hoursTurnover
        },
        {
          title: `${t('totalTradingVolume')}(${ele.settleToken})`,
          val: ele?.tokenDataCalculationDTO?.totalAmount
        },
      ]
    }
    return [
      {
        title: t('avgTradePrice'),
        val: ele?.tokenDataCalculationDTO?.dealPrice
      },
      {
        title: t('participants'),
        val: safeToFormat(ele?.tokenDataCalculationDTO?.totalUid)
      },
      {
        title: `${t('totalTradingVolume')}(${ele.settleToken})`,
        val: ele?.tokenDataCalculationDTO?.totalAmount
      },
    ]
  }

  return (
    <Block
      bgColor="#000"
    >
      <section className={styles.listContent}>
        <ul>{
          showList.map(ele => {
            const status = getTtokenStatus(ele);
            const statusText = getTtokenStatusWriter(ele);
            return (
              <li className={styles.lists} key={ele.tokenName} onClick={() => {
                go(ele.tokenName)
              }}>
                <div className={styles.left}>
                  <div className={styles.content}>
                    <div className={styles.imgs}>
                      <Image src={getProcessedUrl(ele.tokenIcon, {})} alt="" />
                    </div>
                    <section className={styles.name}>
                      <div className={styles.hotText}>
                        <h1 className={styles.topText}>
                          {ele.tokenName || '--'}
                        </h1>
                        {showLabel(ele)}
                      </div>
                      <h2 className={styles.bottomText}>
                        {ele.tokenFullName || '--'}
                      </h2>
                    </section>
                  </div>
                  <p className={styles.state}>
                    {ele.tokenIntroductionDTO?.currencyDesc}
                  </p>
                </div>
                <div className={styles.right}>
                  {ele.showParticipate && isLogin && <p className={styles.partici}>{t('participated')}</p>}
                  <div className={styles.explains}>
                    <section className={styles.explain}>
                      {
                        statusText && marketStore.currentTabName === '1' && <p className={status === Stage['0'] ? styles.comingSoon : styles.avaDelivery}>{statusText}</p>
                      }
                      {
                        statusText && marketStore.currentTabName !== '1' && <p className={styles.pastDelivery}>{statusText}</p>
                      }
                      {showTime(ele)}
                    </section>
                    {ele?.airdropTag === 1 && <TextLink size="small" data-sensors-click onClick={(e) => {
                      e.stopPropagation()
                      sensorsClick({
                        page_name: 'PremarketList',
                        button_name: 'AirdropBtn'
                      })
                      if (!isLogin && checkAccountToRegister('spot_premarket_ongoing')) {
                        return;
                      }
                      window.open(`/${locale}/trade/spot/airdrop-hunt/detail?code=${ele?.airdropId}`)
                    }}>{t('tradeWinMorePrizes')}</TextLink>}
                  </div>

                  <section className={classNames(styles.contents, 'moly-theme-component-dark')}>
                    {status === Stage['0'] ?
                      <div className={styles.countdown}>
                        <p className={styles.countdownText}>
                          {t('tradingStartsIn')}
                        </p>
                        <Countdown
                          size="middle"
                          targetTimestamp={ele.tradeBeginTime}
                          mode="easy"
                          onEnd={() => {
                            window?.location?.reload()
                          }}
                        />
                      </div>
                      :
                      <section className={styles.content}>
                        <p className={styles.line}></p>
                        <p className={styles.lines}></p>
                        <section className={styles.titles}>
                          <p className={styles.topText}>
                            {showItmes(ele)[0]['title']}
                          </p>
                          <p className={styles.topText}>
                            {showItmes(ele)[1]['title']}
                          </p>
                          <p className={styles.topText}>
                            {showItmes(ele)[2]['title']}
                          </p>
                        </section>
                        <div className={styles.fritter}>
                          <div className={styles.bottomText}>
                            {showItmes(ele)[0]['val'] || '--'}
                          </div>
                          <div className={styles.bottomText}>
                            {showItmes(ele)[1]['val'] || '--'}
                          </div>
                          <div className={styles.bottomText}>
                            {showItmes(ele)[2]['val'] || '--'}
                          </div>
                        </div>
                      </section>
                    }
                    <div className={styles.linkText}>
                      {showTradeOrDetailBtn(ele)}
                    </div>
                  </section>
                </div>
              </li>
            )
          })
        }
        </ul>
      </section>
    </Block>
  );
};
